import { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { PsSelectTuner } from 'stencilSetup';
import { PlanLevelCostDto } from 'enrollment/queries/usePlanInformationQuery/utils';

interface CoverageLevelSelectProps {
  planLevelCosts: PlanLevelCostDto;
  selectedCovLevel: string;
  setSelectedCovLevel: Dispatch<SetStateAction<string>>;
  hideLabel?: boolean;
}

export const CoverageLevelSelect = ({
  planLevelCosts,
  selectedCovLevel,
  setSelectedCovLevel,
  hideLabel = false,
}: CoverageLevelSelectProps) => {
  const { t } = useTranslation('pages.enrollmentPlanSelect');

  const coverageLevelLookups = Object.keys(planLevelCosts);
  const coverageLevelNames = Object.entries(planLevelCosts).map(
    (level) => level[1].level_name
  );

  const handleChange = (e: any) => {
    setSelectedCovLevel(e.target.value);
  };

  useEffect(() => {
    if (
      selectedCovLevel === '' ||
      !coverageLevelLookups.includes(selectedCovLevel)
    ) {
      setSelectedCovLevel(coverageLevelLookups[0]);
    }
    // eslint-disable-next-line
  }, []);

  if (coverageLevelLookups.length <= 1) {
    return null;
  }

  return (
    <>
      {hideLabel && (
        <div className="pt-3 pb-2 headline-3">{t('selectCoverageLevel')}</div>
      )}
      <div className="w-100" data-testid="coverage-level-select">
        <PsSelectTuner
          inputId="coverage-level-select"
          label={t('coverageLevel')}
          value={selectedCovLevel}
          onInput={handleChange}
          defaultValue={selectedCovLevel}
          hideLabel={hideLabel}
        >
          {coverageLevelLookups.map((level, index) => {
            return (
              <option key={level} value={level}>
                {coverageLevelNames[index]}
              </option>
            );
          })}
        </PsSelectTuner>
      </div>
    </>
  );
};
